<template>
  <div id="embed" v-if="isAuthenticated">
    <component :is="layout" v-if="currentSkin">
      <router-view />
    </component>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  const defaultLayout = 'default';

  export default {
    name: 'AppEmbed',
    data() {
      return {
        isAuthenticated: false,
      };
    },
    metaInfo: {
      title: process.env.META_TITLA,
      titleTemplate: '%s | ' + process.env.META_TITLA,
      meta: [
        {
          name: 'description',
          content: process.env.META_DESCRIPTION,
        },
      ],
    },
    computed: {
      ...mapGetters({
        currentSkin: 'layout/getCurrentSkin',
      }),
      layout() {
        return `${this.$route.meta.layout || defaultLayout}-layout`;
      },
    },
    methods: {
      ...mapActions('videos', [
        'setCurrentTheme',
        'setKeyword',
        'setCurrentCategory',
        'paginateVideos',
      ]),
      ...mapActions('themes', ['fetchThemes']),
      ...mapActions('layout', ['fetchCurrentSkin']),
      ...mapActions('common', ['getUserParams']),
    },
    mounted() {
      const themeId = this.$route.params.themeId;
      const keyword = this.$route.query.q;
      if (keyword) {
        this.$router.push({ query: { q: keyword } });
      } else if ( this.$route.name !== 'video'){
        const currentCategory = this.$route.params.category || 'trends';
        this.setCurrentCategory(currentCategory);
        this.paginateVideos();
        if (themeId) {
          this.setCurrentTheme(themeId);
        }
      }

    },
    async created() {
      this.fetchCurrentSkin();
      try {
        await this.getUserParams();
        this.isAuthenticated = true;
      } catch (e) {
        this.isAuthenticated = true;
        console.error(e);
      }
    },
  };
</script>

<style lang="scss">
  @import '@/assets/scss/_colors.scss';
  :root {
    --primary-color: #{$primary-color};
    --secondary-color: #{$secondary-color};
  }

  @import '@/assets/scss/_variables.scss';
  @import '../node_modules/bootstrap/scss/bootstrap.scss';

  @import '@/assets/scss/main.scss';

  #app {
    font-family: 'Roboto', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #444444;
    min-height: 100vh;
    background-color: #fafafa;
  }
  .component .uep_player .video-player .video-js {
    height: 100%;
    min-height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/AppEmbed.vue